import React, { useRef, useState, useEffect } from 'react';
import PropTypes from "prop-types";


const Base64ToHtmlComponent = ({ base64Response }) => {

  const [htmlContent, setHtmlContent] = useState("");
  const iframeRef = useRef(null);

  useEffect(() => {

    let decodedHtml = atob(base64Response);
    decodedHtml = decodedHtml.replace(
      /<form([^>]*)>/i,
      "<form$1 target='_top'>"
    );

    setHtmlContent(decodedHtml);
  }, [base64Response]);



  return (
    <div>
      <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', overflow: 'hidden', maxWidth: '100%' }}>
        <iframe
          ref={iframeRef}
          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
          title="Responsive Iframe"
          frameBorder="0"
          srcDoc={htmlContent} // HTML içeriğini iframe içinde çalıştır
          scrolling="no"
        ></iframe>
      </div>
    </div>
  );
};

Base64ToHtmlComponent.propTypes = {
  base64Response: PropTypes.string
};

export default Base64ToHtmlComponent;